export default "__VITE_ASSET__$_fN2eBb__"